import React from "react";
import PageHeroAnchorLink from "../../PageHeroAnchorLink/PageHeroAnchorLink";
import { PageHeroAnchorLinkType } from "../../types/PageHeroAnchor";
//import { navigate } from "gatsby";
import { Builder } from "@builder.io/react";

const PageHeroAnchorLinkWrapper: React.FC<PageHeroAnchorLinkType> = data => {
  const triggerAnalytics = (link: string, text: string) => {
    window?.analytics.track("Marketing CTA Clicked", {
      action: "Clicked",
      initiator: "User",
      object: "Marketing CTA",
      source_application: "Marketing",
      target: link,
      text,
      url: window?.location.pathname,
    });
  };

  const onClick: React.MouseEventHandler<HTMLAnchorElement> = e => {
    //e.preventDefault();
    triggerAnalytics(e.currentTarget.pathname, e.currentTarget.text);
    //navigate(e.currentTarget.href);
  };

  return <PageHeroAnchorLink {...data} onClick={onClick} />;
};

export default PageHeroAnchorLinkWrapper;

export const RegisterPageHeroAnchorLinkWrapper = () => {
  Builder.registerComponent(PageHeroAnchorLinkWrapper, {
    name: "anchor-hero",
    inputs: [
      {
        name: "headline",
        type: "longText",
      },
      {
        name: "subCopy",
        type: "longText",
      },
      {
        name: "ctaCopy",
        type: "string",
      },
      {
        name: "ctaLink",
        type: "reference",
        model: "page",
      },
      {
        name: "ctaUrl",
        type: "string",
      },
      {
        name: "image",
        type: "object",
        required: true,
        subFields: [
          {
            name: "desktop",
            type: "file",
          },
          {
            name: "tablet",
            type: "file",
          },
          {
            name: "mobile",
            type: "file",
          },
          {
            name: "imageAltText",
            type: "string",
          },
        ],
      },
      {
        name: "linkSection",
        type: "list",
        onChange: (options: any) => {
          if (options.get("linkSection").length > 4) {
            options.set("linkSection", options.get("linkSection").slice(0, 4));
            alert("maximum items is 4, delete items to continue");
          }
        },
        subFields: [
          {
            name: "ctaCopy",
            type: "string",
          },
          { name: "ctaUrl", type: "string" },
        ],
      },
    ],
  });
};
